import { render, staticRenderFns } from "./Renovation.vue?vue&type=template&id=df97e0b6&"
import script from "./Renovation.vue?vue&type=script&lang=js&"
export * from "./Renovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports